import { useCallback, useMemo } from 'react'
import { useIntl } from 'react-intl'
import { Outlet, useMatch, useNavigate } from 'react-router'
import { usePageConfig } from '@hooks/usePageConfig'
import ExternalHeaderContent from '@components/ExternalHeaderContent/ExternalHeaderContent'
import HeroBanner from '@components/HeroBanner/HeroBanner'
import Tabs from '@components/Tabs/Tabs'

import './Profile.css'
import TutorialConnectorButton from '@components/TutorialConnectorButton/TutorialConnectorButton'

export default function Profile() {
  const intl = useIntl()
  const navigate = useNavigate()
  const isConnectors = useMatch('/profile/connectors')

  const tabs = useMemo(
    () => [
      { id: 'profile', label: intl.formatMessage({ id: 'tab.profile' }) },
      { id: 'connectors', label: intl.formatMessage({ id: 'tab.connectors' }) }
    ],
    [intl]
  )

  const handleChange = useCallback(
    (id: string) => {
      navigate(id === 'profile' ? '/profile' : `/profile/${id}`)
    },
    [navigate]
  )

  const headerContent = useMemo(() => {
    const crumbs = [
      {
        label: intl.formatMessage({ id: 'nav.profile' }),
        path: '/profile'
      }
    ]
    return (
      <ExternalHeaderContent
        hasBack
        crumbs={crumbs}
        headerActions={<TutorialConnectorButton />}
      />
    )
  }, [intl])

  usePageConfig('profile', headerContent)

  return (
    <section id="profile-content" className="main-content">
      <HeroBanner nameId="profile" />
      <div className="container">
        <Tabs
          tabs={tabs}
          activeTab={isConnectors ? 'connectors' : 'profile'}
          onChange={handleChange}
        />
        <Outlet />
      </div>
    </section>
  )
}
